// extracted by mini-css-extract-plugin
module.exports = {"calTitleCustom":"LoanInterest_calTitleCustom__23n58"};